var _dec, _class, _Rating;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { View } from '@instructure/ui-view';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { omitProps } from '@instructure/ui-react-utils';
import { RatingIcon } from "../RatingIcon/index.js";
import { withStyle } from '@instructure/emotion';
import generateStyle from "./styles.js";
import { allowedProps } from "./props.js";
/**
---
category: components
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let Rating = (_dec = withStyle(generateStyle, null), _dec(_class = (_Rating = class Rating extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  get filled() {
    const _this$props3 = this.props,
      valueNow = _this$props3.valueNow,
      iconCount = _this$props3.iconCount,
      valueMax = _this$props3.valueMax;

    // prevent divide by zero errors
    const max = !!valueMax && valueMax > 0 ? valueMax : iconCount;
    const filledIcons = Math.round(valueNow * iconCount / max);

    // Handle edge case where valueNow is greater than valueMax
    if (filledIcons > iconCount) {
      return iconCount;
    } else {
      return filledIcons;
    }
  }
  get empty() {
    return this.props.iconCount - this.filled;
  }
  render() {
    var _this$props$styles;
    const _this$props4 = this.props,
      iconCount = _this$props4.iconCount,
      animateFill = _this$props4.animateFill,
      size = _this$props4.size,
      margin = _this$props4.margin,
      label = _this$props4.label,
      formatValueText = _this$props4.formatValueText;
    const valueText = label + ' ' + (formatValueText === null || formatValueText === void 0 ? void 0 : formatValueText(this.filled, iconCount));
    const passthroughProps = View.omitViewProps(omitProps(this.props, Rating.allowedProps), Rating);
    return _jsxs(View, {
      ...passthroughProps,
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.rating,
      margin: margin,
      display: "inline-block",
      elementRef: this.handleRef,
      "data-cid": "Rating",
      children: [_jsx(ScreenReaderContent, {
        children: valueText
      }), [...Array(this.filled)].map((_x, i) => _jsx(RatingIcon, {
        filled: true,
        animateFill: animateFill,
        animationDelay: animateFill ? (i + 1) * 200 : void 0,
        size: size
      }, i + 1)), [...Array(this.empty)].map((_x, i) => _jsx(RatingIcon, {
        size: size
      }, i + 1))]
    });
  }
}, _Rating.displayName = "Rating", _Rating.componentId = 'Rating', _Rating.allowedProps = allowedProps, _Rating.defaultProps = {
  animateFill: false,
  formatValueText: (filled, iconCount) => `${filled} / ${iconCount}`,
  iconCount: 3,
  size: 'medium',
  valueNow: 0
}, _Rating.Icon = RatingIcon, _Rating)) || _class);
export default Rating;
export { Rating };